import VendorFormModal from "./VendorFormModal";

export default VendorFormModal;
